import React from 'react';
//import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { NotificationsService } from './services/Notifications';
//import { config } from 'process';
import { createRoot } from 'react-dom/client';

const notificationsService = new NotificationsService();
notificationsService.init();

//ReactDOM.render(<App/>, document.getElementById('root'));

const container = document.getElementById('root');
const root = createRoot(container!); // createRoot(container!) if you use TypeScript
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

serviceWorker.register({notificationsService:notificationsService});

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
//serviceWorker.register();
